interface PgkbLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const sizeMap = {
  sm: { icon: 28, text: 'text-base' },
  md: { icon: 36, text: 'text-xl' },
  lg: { icon: 44, text: 'text-2xl' },
};

export default function PgkbLogo({ size = 'md', showText = true, className = '' }: PgkbLogoProps) {
  const s = sizeMap[size];

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/favicon.svg"
        alt="pgkb"
        width={s.icon}
        height={s.icon}
        className="flex-shrink-0 drop-shadow-sm"
        draggable={false}
      />
      {showText && (
        <span
          className={`${s.text} font-extrabold tracking-tight leading-none`}
          style={{ fontFamily: "'Inter', 'Roboto', system-ui, sans-serif" }}
        >
          <span className="text-slate-900 dark:text-white">pg</span>
          <span className="text-brand-600 dark:text-brand-400">kb</span>
        </span>
      )}
    </div>
  );
}
